module.exports = __webpack_public_path__ + "img/img-9.3c27e69d.png";